import React, { FC, ReactNode } from 'react';
import { Tooltip } from 'react-tooltip';
import styled, { useTheme } from 'styled-components';

import Typography from 'app/ui/components/atoms/typography';
import { Theme } from 'src/app/providers/theme';

interface CustomTooltipProps {
  tooltipText: string;
  children: ReactNode;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  maxWidth?: string;
}

const TooltipWrapper = styled.div`
  display: inline-flex;
`;

const getTooltipStyle = ({ spacing, colors }: Theme, maxWidth: string) => ({
  display: 'flex',
  flexDirection: 'column' as const,
  padding: spacing(3),
  borderRadius: spacing(2),
  maxWidth,
  backgroundColor: colors.blackSwan,
});

const CustomTooltip: FC<CustomTooltipProps> = ({ 
  tooltipText, 
  children, 
  placement = 'top',
  maxWidth = '500px'
}) => {
  const theme = useTheme();
  const tooltipId = `tooltip-${Math.random().toString(36).substring(2, 9)}`;

  return (
    <>
      <TooltipWrapper data-tooltip-id={tooltipId}>
        {children}
      </TooltipWrapper>
      <Tooltip
        id={tooltipId}
        style={getTooltipStyle(theme, maxWidth)}
        border={`2px solid ${theme.colors.devilsGray}`}
        place={placement}
        opacity={1}
      >
        <Typography variant='caption'>{tooltipText}</Typography>
      </Tooltip>
    </>
  );
};

export default CustomTooltip;
